import type { MediaType } from "@/generated/graphql";
import { FiUpload } from "react-icons/fi";
import { getMediaConfig } from "../config";

interface ReplaceFilePanelProps {
  /** Media type being replaced */
  mediaType: MediaType;
  /** Current filename */
  currentFilename: string;
}

/**
 * ReplaceFilePanel - Panel for replacing media file
 *
 * Placeholder for file replacement functionality.
 * Requires ReplaceMediaFile mutation on backend.
 */
export function ReplaceFilePanel({ mediaType, currentFilename }: ReplaceFilePanelProps) {
  const config = getMediaConfig(mediaType);

  return (
    <div className="space-y-4">
      <div>
        <h3 className="mb-2 text-lg font-semibold text-gray-900">
          Replace {config.label.toLowerCase()}
        </h3>
        <p className="text-sm text-gray-600">
          Upload a file to replace <span className="font-medium">{currentFilename}</span>
        </p>
      </div>

      {/* Drop zone placeholder */}
      <div className="rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 p-8 text-center">
        <div className="flex flex-col items-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-200">
            <FiUpload className="h-6 w-6 text-gray-500" />
          </div>
          <p className="mt-4 text-sm font-medium text-gray-900">
            Drop {config.label.toLowerCase()} file here
          </p>
          <p className="mt-1 text-xs text-gray-500">or click to browse</p>
        </div>
      </div>

      {/* Info box */}
      <div className="rounded-md bg-blue-50 p-3">
        <p className="text-sm text-blue-700">File replacement requires backend API support.</p>
        <p className="mt-1 text-xs text-blue-600">
          Accepted formats: {config.acceptedMimeTypes.split(",").join(", ")}
        </p>
      </div>
    </div>
  );
}

export default ReplaceFilePanel;
